// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"8be8e567","356":"3809156b","376":"817d27d9","568":"6c87a7ac","584":"6c87a7ac","708":"a724a546","755":"d46476c3"}[chunkId] + ".chunk.css";
};